import React, { Component } from 'react';
import firebase from '../../store/firebase';
import { getAuth, updateUser } from "firebase/auth";
import axios from 'axios';
import { FB_URL, SHOW_TOAST } from '../../store/actions/types';

class DailyToggleScheduler extends Component {
  constructor(props) {
    super(props);

    this.state = {
      onTime: '',
      offTime: '',
      timeInputOn: '',
      timeInputOff: ''
    };

    console.log('DailyTogg 1: ');
    console.log('DailyTogg 2: ');
  }

  componentDidMount() {
    const onRef = firebase.database.ref('/settings/dailyOnTime');
    const offRef = firebase.database.ref('/settings/dailyOffTime');

    console.log('DailyTogg 3: ');
    console.log('🔄 Listening for schedule changes in Firebase...');

    onRef.on('value', (snap) => {
      const val = snap.val() || '';
      this.setState({ onTime: val, timeInputOn: val });
      console.log('📥 Loaded ON time from DB:', val);
      console.log('DailyTogg 4: ', val);
    });

    offRef.on('value', (snap) => {
      const val = snap.val() || '';
      this.setState({ offTime: val, timeInputOff: val });
      console.log('📥 Loaded OFF time from DB:', val);
      console.log('DailyTogg 5: ', val);
    });

    // Store references so we can clean up
    this.onRef = onRef;
    this.offRef = offRef;
  }

  componentWillUnmount() {
    if (this.onRef) this.onRef.off();
    if (this.offRef) this.offRef.off();
  }

  handleSaveSchedule = async() => {
    var updates = {};
     updates['settings/dailyOnTime'] = this.state.timeInputOn;
     updates['settings/dailyOffTime'] = this.state.timeInputOff;

    // firebase.database.ref('/settings/dailyOnTime').set(this.state.timeInputOn || null);
    // firebase.database.ref('/settings/dailyOffTime').set(this.state.timeInputOff || null);

    try {
      var res = await axios.post(`${FB_URL}/m115-freshcard`, {
        params: {
          updates: updates,
        },
      });

      if (res.data && res.data.success === true) {
        console.log("handleSaveSchedule success!");
      } else {
        console.log("handleSaveSchedule Error:");
      }
    } catch (err) {
      console.log("handleSaveSchedule failed:", err);
    }

    console.log(`DailyTogg ✅ Saved to Firebase → ON: ${this.state.timeInputOn || '—'} | OFF: ${this.state.timeInputOff || '—'}`);
  };

  handleClearSchedule = async() => {
    var updatesc = {};
     updatesc['settings/dailyOnTime'] = null;
     updatesc['settings/dailyOffTime'] = null;

    //firebase.database.ref('/settings/dailyOnTime').set(null);
    //firebase.database.ref('/settings/dailyOffTime').set(null);

     try {
      var res = await axios.post(`${FB_URL}/m115-freshcard`, {
        params: {
          updatesc: updatesc,
        },
      });

      if (res.data && res.data.success === true) {
        console.log("handleClearSchedule success!");
      } else {
        console.log("handleClearSchedule Error:");
      }
    } catch (err) {
      console.log("handleClearSchedule failed:", err);
    }
    console.log('DailyTogg 🗑️ Cleared both schedules from Firebase');
  };

  forceOnNow = () => {
    firebase.database.ref('patreon/LcExchangeon').set(true);
    console.log('DailyTogg 🔧 Force ON executed from admin panel');
  };

  forceOffNow = () => {
    firebase.database.ref('patreon/LcExchangeon').set(false);
    console.log('DailyTogg 🔧 Force OFF executed from admin panel');
  };

  getNextTriggerString = (time) => {
    if (!time) return 'Not set';
    const now = new Date();
    const [hours, minutes] = time.split(':').map(Number);
    let next = new Date(now.getFullYear(), now.getMonth(), now.getDate(), hours, minutes, 0, 0);
    if (next <= now) next.setDate(next.getDate() + 1);
    return next.toLocaleString('en-US', {
      weekday: 'short',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
    });
  };

  render() {
    const { onTime, offTime, timeInputOn, timeInputOff } = this.state;

    return (
      <div style={{
        padding: '9px',
        border: '1px solid #ccc',
        borderRadius: '8px',
        maxWidth: '410px',                 // between 480px and 336px
        margin: '20px 0',                  // left-aligned
        fontFamily: 'system-ui, sans-serif',
        background: '#f9f9f9'
      }}>
        <h3 style={{ fontSize: '19px' }}>⏰ Daily ON / OFF Scheduler (Backend)</h3>
        <p style={{ marginBottom: '16px', color: '#555', fontSize: '14px' }}>
          Times are saved in Firebase.<br />
          <strong>Cloud Scheduler</strong> calls the function every minute — works even if this page is closed.
        </p>

        {/* ON */}
        <div style={{ marginBottom: '16px' }}>
          <label style={{ display: 'block', marginBottom: '6px', fontWeight: 600, color: '#28a745', fontSize: '14px' }}>
            Turn ON every day at:
          </label>
          <input
            type="time"
            value={timeInputOn}
            onChange={(e) => this.setState({ timeInputOn: e.target.value })}
            style={{
              padding: '9px',
              fontSize: '14px',
              borderRadius: '4px',
              border: '1px solid #999',
              width: '100%'
            }}
          />
        </div>

        {/* OFF */}
        <div style={{ marginBottom: '16px' }}>
          <label style={{ display: 'block', marginBottom: '6px', fontWeight: 600, color: '#dc3545', fontSize: '14px' }}>
            Turn OFF every day at:
          </label>
          <input
            type="time"
            value={timeInputOff}
            onChange={(e) => this.setState({ timeInputOff: e.target.value })}
            style={{
              padding: '9px',
              fontSize: '14px',
              borderRadius: '4px',
              border: '1px solid #999',
              width: '100%'
            }}
          />
        </div>

        <div style={{ display: 'flex', gap: '9px', marginBottom: '16px' }}>
          <button
            onClick={this.handleSaveSchedule}
            style={{
              flex: 1,
              padding: '10px',
              background: '#007bff',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              fontSize: '14px',
              cursor: 'pointer'
            }}
          >
            💾 Save Both Times
          </button>

          <button
            onClick={this.handleClearSchedule}
            style={{
              flex: 1,
              padding: '10px',
              background: '#dc3545',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              fontSize: '14px',
              cursor: 'pointer'
            }}
          >
            🗑️ Clear Both
          </button>
        </div>

        {/* Live status from Firebase */}
        <div style={{
          padding: '10px',
          background: '#f0f0f0',
          borderRadius: '4px',
          fontSize: '14px',
          lineHeight: '1.45'
        }}>
          <strong>Current ON time in DB:</strong> {onTime || 'Not set'}<br />
          <strong>Current OFF time in DB:</strong> {offTime || 'Not set'}<br />
          <strong>Next ON (client preview):</strong> {this.getNextTriggerString(onTime)}<br />
          <strong>Next OFF (client preview):</strong> {this.getNextTriggerString(offTime)}
        </div>

        <small style={{ display: 'block', marginTop: '14px', color: '#666', fontSize: '12px' }}>
          ✅ The time pickers now auto-fill with whatever is saved in Firebase.<br />
          Check the browser console for detailed logs.<br />
          Cloud function must match the exact "HH:mm" string (JHB time).
        </small>
      </div>
    );
  }

  // render() {
  //   const { onTime, offTime, timeInputOn, timeInputOff } = this.state;

  //   return (
  //     <div style={{
  //       padding: '10px',
  //       border: '1px solid #ccc',
  //       borderRadius: '8px',
  //       maxWidth: '480px',
  //       margin: '20px auto',
  //       fontFamily: 'system-ui, sans-serif',
  //       background: '#f9f9f9'
  //     }}>
  //       <h3>⏰ Daily ON / OFF Scheduler (Backend)</h3>
  //       <p style={{ marginBottom: '20px', color: '#555' }}>
  //         Times are saved in Firebase.<br />
  //         <strong>Cloud Scheduler</strong> calls the function every minute — works even if this page is closed.
  //       </p>

  //       {/* ON */}
  //       <div style={{ marginBottom: '20px' }}>
  //         <label style={{ display: 'block', marginBottom: '5px', fontWeight: 600, color: '#28a745' }}>
  //           Turn ON every day at:
  //         </label>
  //         <input
  //           type="time"
  //           value={timeInputOn}
  //           onChange={(e) => this.setState({ timeInputOn: e.target.value })}
  //           style={{
  //             padding: '10px',
  //             fontSize: '16px',
  //             borderRadius: '4px',
  //             border: '1px solid #999',
  //             width: '100%'
  //           }}
  //         />
  //       </div>

  //       {/* OFF */}
  //       <div style={{ marginBottom: '20px' }}>
  //         <label style={{ display: 'block', marginBottom: '5px', fontWeight: 600, color: '#dc3545' }}>
  //           Turn OFF every day at:
  //         </label>
  //         <input
  //           type="time"
  //           value={timeInputOff}
  //           onChange={(e) => this.setState({ timeInputOff: e.target.value })}
  //           style={{
  //             padding: '10px',
  //             fontSize: '16px',
  //             borderRadius: '4px',
  //             border: '1px solid #999',
  //             width: '100%'
  //           }}
  //         />
  //       </div>

  //       <div style={{ display: 'flex', gap: '10px', marginBottom: '20px' }}>
  //         <button
  //           onClick={this.handleSaveSchedule}
  //           style={{
  //             flex: 1,
  //             padding: '12px',
  //             background: '#007bff',
  //             color: 'white',
  //             border: 'none',
  //             borderRadius: '4px',
  //             fontSize: '16px',
  //             cursor: 'pointer'
  //           }}
  //         >
  //           💾 Save Both Times
  //         </button>

  //         <button
  //           onClick={this.handleClearSchedule}
  //           style={{
  //             flex: 1,
  //             padding: '12px',
  //             background: '#dc3545',
  //             color: 'white',
  //             border: 'none',
  //             borderRadius: '4px',
  //             fontSize: '16px',
  //             cursor: 'pointer'
  //           }}
  //         >
  //           🗑️ Clear Both
  //         </button>
  //       </div>

  //       {/* Quick test buttons */}
  //       <div style={{ display: 'flex', gap: '10px', marginBottom: '20px' }}>
  //         <button
  //           onClick={this.forceOnNow}
  //           style={{
  //             flex: 1,
  //             padding: '10px',
  //             background: '#28a745',
  //             color: 'white',
  //             border: 'none',
  //             borderRadius: '4px',
  //             fontSize: '15px',
  //             cursor: 'pointer'
  //           }}
  //         >
  //           🔧 Force ON Now (test)
  //         </button>
  //         <button
  //           onClick={this.forceOffNow}
  //           style={{
  //             flex: 1,
  //             padding: '10px',
  //             background: '#dc3545',
  //             color: 'white',
  //             border: 'none',
  //             borderRadius: '4px',
  //             fontSize: '15px',
  //             cursor: 'pointer'
  //           }}
  //         >
  //           🔧 Force OFF Now (test)
  //         </button>
  //       </div>

  //       {/* Live status from Firebase */}
  //       <div style={{
  //         padding: '12px',
  //         background: '#f0f0f0',
  //         borderRadius: '4px',
  //         fontSize: '15px',
  //         lineHeight: '1.5'
  //       }}>
  //         <strong>Current ON time in DB:</strong> {onTime || 'Not set'}<br />
  //         <strong>Current OFF time in DB:</strong> {offTime || 'Not set'}<br />
  //         <strong>Next ON (client preview):</strong> {this.getNextTriggerString(onTime)}<br />
  //         <strong>Next OFF (client preview):</strong> {this.getNextTriggerString(offTime)}
  //       </div>

  //       <small style={{ display: 'block', marginTop: '15px', color: '#666' }}>
  //         ✅ The time pickers now auto-fill with whatever is saved in Firebase.<br />
  //         Check the browser console for detailed logs.<br />
  //         Cloud function must match the exact "HH:mm" string (JHB time).
  //       </small>
  //     </div>
  //   );
  // }
}

export default DailyToggleScheduler;
////////////////////////////////////////////////////////////////////////////////////////////
// import React, { useState, useEffect } from 'react';
// import firebase from '../../store/firebase';
// import { getAuth, updateUser } from "firebase/auth";

// const DailyToggleScheduler = () => {
//   const [onTime, setOnTime] = useState('');
//   const [offTime, setOffTime] = useState('');
//  console.log('DailyTogg 1: ');
//   // Editing inputs (these will now auto-fill with saved values)
//   const [timeInputOn, setTimeInputOn] = useState('');
//   const [timeInputOff, setTimeInputOff] = useState('');
// console.log('DailyTogg 2: ');
//   // Load from Firebase + auto-sync the input fields so they show current schedule
//   useEffect(() => {
//     const onRef = firebase.database.ref('/settings/dailyOnTime');
//     const offRef = firebase.database.ref('/settings/dailyOffTime');
// console.log('DailyTogg 3: ');
//     console.log('🔄 Listening for schedule changes in Firebase...');

//     onRef.on('value', (snap) => {
//       const val = snap.val() || '';
//       setOnTime(val);
//       setTimeInputOn(val);        // ← THIS WAS MISSING → now inputs pre-fill
//       console.log('📥 Loaded ON time from DB:', val);
//       console.log('DailyTogg 4: ', val);
//     });

//     offRef.on('value', (snap) => {
//       const val = snap.val() || '';
//       setOffTime(val);
//       setTimeInputOff(val);       // ← THIS WAS MISSING → now inputs pre-fill
//       console.log('📥 Loaded OFF time from DB:', val);
//        console.log('DailyTogg 5: ', val);
//     });

//     return () => {
//       onRef.off();
//       offRef.off();
//     };
//   }, []);

//   const handleSaveSchedule = () => {
//     firebase.database.ref('/settings/dailyOnTime').set(timeInputOn || null);
//     firebase.database.ref('/settings/dailyOffTime').set(timeInputOff || null);

//     console.log(`DailyTogg ✅ Saved to Firebase → ON: ${timeInputOn || '—'} | OFF: ${timeInputOff || '—'}`);
//   };

//   const handleClearSchedule = () => {
//     firebase.database.ref('/settings/dailyOnTime').set(null);
//     firebase.database.ref('/settings/dailyOffTime').set(null);
//     console.log('DailyTogg 🗑️ Cleared both schedules from Firebase');
//   };

//   // Quick debug / test buttons (write directly to the same path the cloud function uses)
//   const forceOnNow = () => {
//     firebase.database.ref('patreon/LcExchangeon').set(true);
//     console.log('DailyTogg 🔧 Force ON executed from admin panel');
//   };

//   const forceOffNow = () => {
//     firebase.database.ref('patreon/LcExchangeon').set(false);
//     console.log('DailyTogg 🔧 Force OFF executed from admin panel');
//   };

//   const getNextTriggerString = (time) => {
//     if (!time) return 'Not set';
//     const now = new Date();
//     const [hours, minutes] = time.split(':').map(Number);
//     let next = new Date(now.getFullYear(), now.getMonth(), now.getDate(), hours, minutes, 0, 0);
//     if (next <= now) next.setDate(next.getDate() + 1);
//     return next.toLocaleString('en-US', {
//       weekday: 'short',
//       month: 'short',
//       day: 'numeric',
//       hour: 'numeric',
//       minute: '2-digit',
//     });
//   };

//   return (
//     <div style={{
//       padding: '10px',
//       border: '1px solid #ccc',
//       borderRadius: '8px',
//       maxWidth: '480px',
//       margin: '20px auto',
//       fontFamily: 'system-ui, sans-serif',
//       background: '#f9f9f9'
//     }}>
//       <h3>⏰ Daily ON / OFF Scheduler (Backend)</h3>
//       <p style={{ marginBottom: '20px', color: '#555' }}>
//         Times are saved in Firebase.<br />
//         <strong>Cloud Scheduler</strong> calls the function every minute — works even if this page is closed.
//       </p>

//       {/* ON */}
//       <div style={{ marginBottom: '20px' }}>
//         <label style={{ display: 'block', marginBottom: '5px', fontWeight: 600, color: '#28a745' }}>
//           Turn ON every day at:
//         </label>
//         <input
//           type="time"
//           value={timeInputOn}
//           onChange={(e) => setTimeInputOn(e.target.value)}
//           style={{
//             padding: '10px',
//             fontSize: '16px',
//             borderRadius: '4px',
//             border: '1px solid #999',
//             width: '100%'
//           }}
//         />
//       </div>

//       {/* OFF */}
//       <div style={{ marginBottom: '20px' }}>
//         <label style={{ display: 'block', marginBottom: '5px', fontWeight: 600, color: '#dc3545' }}>
//           Turn OFF every day at:
//         </label>
//         <input
//           type="time"
//           value={timeInputOff}
//           onChange={(e) => setTimeInputOff(e.target.value)}
//           style={{
//             padding: '10px',
//             fontSize: '16px',
//             borderRadius: '4px',
//             border: '1px solid #999',
//             width: '100%'
//           }}
//         />
//       </div>

//       <div style={{ display: 'flex', gap: '10px', marginBottom: '20px' }}>
//         <button
//           onClick={handleSaveSchedule}
//           style={{
//             flex: 1,
//             padding: '12px',
//             background: '#007bff',
//             color: 'white',
//             border: 'none',
//             borderRadius: '4px',
//             fontSize: '16px',
//             cursor: 'pointer'
//           }}
//         >
//           💾 Save Both Times
//         </button>

//         <button
//           onClick={handleClearSchedule}
//           style={{
//             flex: 1,
//             padding: '12px',
//             background: '#dc3545',
//             color: 'white',
//             border: 'none',
//             borderRadius: '4px',
//             fontSize: '16px',
//             cursor: 'pointer'
//           }}
//         >
//           🗑️ Clear Both
//         </button>
//       </div>

//       {/* Quick test buttons */}
//       <div style={{ display: 'flex', gap: '10px', marginBottom: '20px' }}>
//         <button
//           onClick={forceOnNow}
//           style={{
//             flex: 1,
//             padding: '10px',
//             background: '#28a745',
//             color: 'white',
//             border: 'none',
//             borderRadius: '4px',
//             fontSize: '15px',
//             cursor: 'pointer'
//           }}
//         >
//           🔧 Force ON Now (test)
//         </button>
//         <button
//           onClick={forceOffNow}
//           style={{
//             flex: 1,
//             padding: '10px',
//             background: '#dc3545',
//             color: 'white',
//             border: 'none',
//             borderRadius: '4px',
//             fontSize: '15px',
//             cursor: 'pointer'
//           }}
//         >
//           🔧 Force OFF Now (test)
//         </button>
//       </div>

//       {/* Live status from Firebase */}
//       <div style={{
//         padding: '12px',
//         background: '#f0f0f0',
//         borderRadius: '4px',
//         fontSize: '15px',
//         lineHeight: '1.5'
//       }}>
//         <strong>Current ON time in DB:</strong> {onTime || 'Not set'}<br />
//         <strong>Current OFF time in DB:</strong> {offTime || 'Not set'}<br />
//         <strong>Next ON (client preview):</strong> {getNextTriggerString(onTime)}<br />
//         <strong>Next OFF (client preview):</strong> {getNextTriggerString(offTime)}
//       </div>

//       <small style={{ display: 'block', marginTop: '15px', color: '#666' }}>
//         ✅ The time pickers now auto-fill with whatever is saved in Firebase.<br />
//         Check the browser console for detailed logs.<br />
//         Cloud function must match the exact "HH:mm" string (JHB time).
//       </small>
//     </div>
//   );
// };

// export default DailyToggleScheduler;
//////////////////////////////////////////////////////////////////////////////////////////
// import React, { useState, useEffect } from 'react';
// import firebase from '../../store/firebase';
// import { getAuth, updateUser } from "firebase/auth";

// const DailyToggleScheduler = () => {
//   const [onTime, setOnTime] = useState('');
//   const [offTime, setOffTime] = useState('');
//  console.log('DailyTogg 1: ');
//   // Editing inputs (these will now auto-fill with saved values)
//   const [timeInputOn, setTimeInputOn] = useState('');
//   const [timeInputOff, setTimeInputOff] = useState('');
// console.log('DailyTogg 2: ');
//   // Load from Firebase + auto-sync the input fields so they show current schedule
//   useEffect(() => {
//     const onRef = firebase.database.ref('/settings/dailyOnTime');
//     const offRef = firebase.database.ref('/settings/dailyOffTime');
// console.log('DailyTogg 3: ');
//     console.log('🔄 Listening for schedule changes in Firebase...');

//     onRef.on('value', (snap) => {
//       const val = snap.val() || '';
//       setOnTime(val);
//       setTimeInputOn(val);        // ← THIS WAS MISSING → now inputs pre-fill
//       console.log('📥 Loaded ON time from DB:', val);
//       console.log('DailyTogg 4: ', val);
//     });

//     offRef.on('value', (snap) => {
//       const val = snap.val() || '';
//       setOffTime(val);
//       setTimeInputOff(val);       // ← THIS WAS MISSING → now inputs pre-fill
//       console.log('📥 Loaded OFF time from DB:', val);
//        console.log('DailyTogg 5: ', val);
//     });

//     return () => {
//       onRef.off();
//       offRef.off();
//     };
//   }, []);

//   const handleSaveSchedule = () => {
//     firebase.database.ref('/settings/dailyOnTime').set(timeInputOn || null);
//     firebase.database.ref('/settings/dailyOffTime').set(timeInputOff || null);

//     console.log(`DailyTogg ✅ Saved to Firebase → ON: ${timeInputOn || '—'} | OFF: ${timeInputOff || '—'}`);
//   };

//   const handleClearSchedule = () => {
//     firebase.database.ref('/settings/dailyOnTime').set(null);
//     firebase.database.ref('/settings/dailyOffTime').set(null);
//     console.log('DailyTogg 🗑️ Cleared both schedules from Firebase');
//   };

//   // Quick debug / test buttons (write directly to the same path the cloud function uses)
//   const forceOnNow = () => {
//     firebase.database.ref('patreon/LcExchangeon').set(true);
//     console.log('DailyTogg 🔧 Force ON executed from admin panel');
//   };

//   const forceOffNow = () => {
//     firebase.database.ref('patreon/LcExchangeon').set(false);
//     console.log('DailyTogg 🔧 Force OFF executed from admin panel');
//   };

//   const getNextTriggerString = (time) => {
//     if (!time) return 'Not set';
//     const now = new Date();
//     const [hours, minutes] = time.split(':').map(Number);
//     let next = new Date(now.getFullYear(), now.getMonth(), now.getDate(), hours, minutes, 0, 0);
//     if (next <= now) next.setDate(next.getDate() + 1);
//     return next.toLocaleString('en-US', {
//       weekday: 'short',
//       month: 'short',
//       day: 'numeric',
//       hour: 'numeric',
//       minute: '2-digit',
//     });
//   };

//   return (
//     <div style={{
//       padding: '10px',
//       border: '1px solid #ccc',
//       borderRadius: '8px',
//       maxWidth: '480px',
//       margin: '20px auto',
//       fontFamily: 'system-ui, sans-serif',
//       background: '#f9f9f9'
//     }}>
//       <h3>⏰ Daily ON / OFF Scheduler (Backend)</h3>
//       <p style={{ marginBottom: '20px', color: '#555' }}>
//         Times are saved in Firebase.<br />
//         <strong>Cloud Scheduler</strong> calls the function every minute — works even if this page is closed.
//       </p>

//       {/* ON */}
//       <div style={{ marginBottom: '20px' }}>
//         <label style={{ display: 'block', marginBottom: '5px', fontWeight: 600, color: '#28a745' }}>
//           Turn ON every day at:
//         </label>
//         <input
//           type="time"
//           value={timeInputOn}
//           onChange={(e) => setTimeInputOn(e.target.value)}
//           style={{
//             padding: '10px',
//             fontSize: '16px',
//             borderRadius: '4px',
//             border: '1px solid #999',
//             width: '100%'
//           }}
//         />
//       </div>

//       {/* OFF */}
//       <div style={{ marginBottom: '20px' }}>
//         <label style={{ display: 'block', marginBottom: '5px', fontWeight: 600, color: '#dc3545' }}>
//           Turn OFF every day at:
//         </label>
//         <input
//           type="time"
//           value={timeInputOff}
//           onChange={(e) => setTimeInputOff(e.target.value)}
//           style={{
//             padding: '10px',
//             fontSize: '16px',
//             borderRadius: '4px',
//             border: '1px solid #999',
//             width: '100%'
//           }}
//         />
//       </div>

//       <div style={{ display: 'flex', gap: '10px', marginBottom: '20px' }}>
//         <button
//           onClick={handleSaveSchedule}
//           style={{
//             flex: 1,
//             padding: '12px',
//             background: '#007bff',
//             color: 'white',
//             border: 'none',
//             borderRadius: '4px',
//             fontSize: '16px',
//             cursor: 'pointer'
//           }}
//         >
//           💾 Save Both Times
//         </button>

//         <button
//           onClick={handleClearSchedule}
//           style={{
//             flex: 1,
//             padding: '12px',
//             background: '#dc3545',
//             color: 'white',
//             border: 'none',
//             borderRadius: '4px',
//             fontSize: '16px',
//             cursor: 'pointer'
//           }}
//         >
//           🗑️ Clear Both
//         </button>
//       </div>

//       {/* Quick test buttons */}
//       <div style={{ display: 'flex', gap: '10px', marginBottom: '20px' }}>
//         <button
//           onClick={forceOnNow}
//           style={{
//             flex: 1,
//             padding: '10px',
//             background: '#28a745',
//             color: 'white',
//             border: 'none',
//             borderRadius: '4px',
//             fontSize: '15px',
//             cursor: 'pointer'
//           }}
//         >
//           🔧 Force ON Now (test)
//         </button>
//         <button
//           onClick={forceOffNow}
//           style={{
//             flex: 1,
//             padding: '10px',
//             background: '#dc3545',
//             color: 'white',
//             border: 'none',
//             borderRadius: '4px',
//             fontSize: '15px',
//             cursor: 'pointer'
//           }}
//         >
//           🔧 Force OFF Now (test)
//         </button>
//       </div>

//       {/* Live status from Firebase */}
//       <div style={{
//         padding: '12px',
//         background: '#f0f0f0',
//         borderRadius: '4px',
//         fontSize: '15px',
//         lineHeight: '1.5'
//       }}>
//         <strong>Current ON time in DB:</strong> {onTime || 'Not set'}<br />
//         <strong>Current OFF time in DB:</strong> {offTime || 'Not set'}<br />
//         <strong>Next ON (client preview):</strong> {getNextTriggerString(onTime)}<br />
//         <strong>Next OFF (client preview):</strong> {getNextTriggerString(offTime)}
//       </div>

//       <small style={{ display: 'block', marginTop: '15px', color: '#666' }}>
//         ✅ The time pickers now auto-fill with whatever is saved in Firebase.<br />
//         Check the browser console for detailed logs.<br />
//         Cloud function must match the exact "HH:mm" string (JHB time).
//       </small>
//     </div>
//   );
// };

// export default DailyToggleScheduler;
///////////////////////////////////////////////////////////////////////////////////////
// import React, { useState, useEffect } from 'react';
// import firebase from '../../store/firebase';
// import { getAuth, updateUser } from "firebase/auth";

// const DailyToggleScheduler = () => {
//   const [onTime, setOnTime] = useState('');
//   const [offTime, setOffTime] = useState('');
//   const [timeInputOn, setTimeInputOn] = useState('');
//   const [timeInputOff, setTimeInputOff] = useState('');

//   // Load current schedule from Firebase DB
//   useEffect(() => {
//     const onRef = firebase.database.ref('/settings/dailyOnTime');
//     const offRef = firebase.database.ref('/settings/dailyOffTime');

//     onRef.on('value', (snap) => setOnTime(snap.val() || ''));
//     offRef.on('value', (snap) => setOffTime(snap.val() || ''));

//     return () => {
//       onRef.off();
//       offRef.off();
//     };
//   }, []);

//   const handleSaveSchedule = () => {
//     firebase.database.ref('/settings/dailyOnTime').set(timeInputOn || null);
//     firebase.database.ref('/settings/dailyOffTime').set(timeInputOff || null);

//     console.log(`📅 Daily schedule saved → ON at ${timeInputOn || '—'} | OFF at ${timeInputOff || '—'}`);
//   };

//   const handleClearSchedule = () => {
//     firebase.database.ref('/settings/dailyOnTime').set(null);
//     firebase.database.ref('/settings/dailyOffTime').set(null);
//     setTimeInputOn('');
//     setTimeInputOff('');
//     console.log('🗑️ Both daily schedules cleared');
//   };

//   const getNextTriggerString = (time) => {
//     if (!time) return 'Not set';
//     const now = new Date();
//     const [hours, minutes] = time.split(':').map(Number);
//     let next = new Date(now.getFullYear(), now.getMonth(), now.getDate(), hours, minutes, 0, 0);
//     if (next <= now) next.setDate(next.getDate() + 1);
//     return next.toLocaleString('en-US', {
//       weekday: 'short',
//       month: 'short',
//       day: 'numeric',
//       hour: 'numeric',
//       minute: '2-digit',
//     });
//   };

//   return (
//     <div style={{
//       padding: '20px',
//       border: '1px solid #ccc',
//       borderRadius: '8px',
//       maxWidth: '460px',
//       margin: '20px auto',
//       fontFamily: 'system-ui, sans-serif',
//       background: '#f9f9f9'
//     }}>
//       <h3>⏰ Daily ON / OFF Scheduler (Backend)</h3>
//       <p style={{ marginBottom: '20px', color: '#555' }}>
//         Times are now stored in Firebase. A backend function will run the toggle <strong>every day automatically</strong> — even if this app is closed.
//       </p>

//       <div style={{ marginBottom: '20px' }}>
//         <label style={{ display: 'block', marginBottom: '5px', fontWeight: 600, color: '#28a745' }}>
//           Turn ON every day at:
//         </label>
//         <input
//           type="time"
//           value={timeInputOn}
//           onChange={(e) => setTimeInputOn(e.target.value)}
//           style={{ padding: '10px', fontSize: '16px', borderRadius: '4px', border: '1px solid #999', width: '100%' }}
//         />
//       </div>

//       <div style={{ marginBottom: '20px' }}>
//         <label style={{ display: 'block', marginBottom: '5px', fontWeight: 600, color: '#dc3545' }}>
//           Turn OFF every day at:
//         </label>
//         <input
//           type="time"
//           value={timeInputOff}
//           onChange={(e) => setTimeInputOff(e.target.value)}
//           style={{ padding: '10px', fontSize: '16px', borderRadius: '4px', border: '1px solid #999', width: '100%' }}
//         />
//       </div>

//       <div style={{ display: 'flex', gap: '10px', marginBottom: '20px' }}>
//         <button onClick={handleSaveSchedule} style={{ flex: 1, padding: '12px', background: '#007bff', color: 'white', border: 'none', borderRadius: '4px', fontSize: '16px', cursor: 'pointer' }}>
//           💾 Save Both Times
//         </button>
//         <button onClick={handleClearSchedule} style={{ flex: 1, padding: '12px', background: '#dc3545', color: 'white', border: 'none', borderRadius: '4px', fontSize: '16px', cursor: 'pointer' }}>
//           🗑️ Clear Both
//         </button>
//       </div>

//       <div style={{ padding: '12px', background: '#f0f0f0', borderRadius: '4px', fontSize: '15px', lineHeight: '1.5' }}>
//         <strong>Current ON time:</strong> {onTime || 'Not set'}<br />
//         <strong>Current OFF time:</strong> {offTime || 'Not set'}<br />
//         <strong>Next ON:</strong> {getNextTriggerString(onTime)}<br />
//         <strong>Next OFF:</strong> {getNextTriggerString(offTime)}
//       </div>

//       <small style={{ display: 'block', marginTop: '15px', color: '#666' }}>
//         Note: Times are in UTC (server time). The backend checker runs every minute.
//       </small>
//     </div>
//   );
// };

// export default DailyToggleScheduler;
////////////////////////////////////////////////////////////////////////////////////////
// // === 2. REPLACE your entire DailyToggleScheduler.js with this new version ===

// import React, { useState, useEffect, useRef, useCallback } from 'react';

// const DailyToggleScheduler = ({ handleToggle }) => {
//   // Load saved times from localStorage
//   const [onTime, setOnTime] = useState(() => {
//     return localStorage.getItem('dailyOnTime') || '';
//   });
//   const [offTime, setOffTime] = useState(() => {
//     return localStorage.getItem('dailyOffTime') || '';
//   });

//   // Temporary inputs for the time pickers
//   const [timeInputOn, setTimeInputOn] = useState(onTime);
//   const [timeInputOff, setTimeInputOff] = useState(offTime);

//   const onTimeoutRef = useRef(null);
//   const offTimeoutRef = useRef(null);

//   // Reusable scheduler (handles both ON and OFF)
//   const scheduleAction = useCallback((scheduledTime, targetValue, timeoutRef, actionName) => {
//     if (!scheduledTime || !handleToggle) return;

//     if (timeoutRef.current) {
//       clearTimeout(timeoutRef.current);
//     }

//     const now = new Date();
//     const [hours, minutes] = scheduledTime.split(':').map(Number);

//     let nextTrigger = new Date(
//       now.getFullYear(),
//       now.getMonth(),
//       now.getDate(),
//       hours,
//       minutes,
//       0,
//       0
//     );

//     if (nextTrigger <= now) {
//       nextTrigger.setDate(nextTrigger.getDate() + 1);
//     }

//     const delayMs = nextTrigger.getTime() - now.getTime();

//     console.log(
//       `✅ ${actionName} scheduled for ${nextTrigger.toLocaleString()} ` +
//       `(${Math.round(delayMs / 1000 / 60)} minutes from now)`
//     );

//     timeoutRef.current = setTimeout(() => {
//       console.log(`🚀 Running scheduled ${actionName} (force ${targetValue})...`);
//       handleToggle(targetValue);   // ← forces ON or OFF

//       // Automatically reschedule for the next day
//       scheduleAction(scheduledTime, targetValue, timeoutRef, actionName);
//     }, delayMs);
//   }, [handleToggle]);

//   // Schedule the ON action whenever onTime changes
//   useEffect(() => {
//     scheduleAction(onTime, true, onTimeoutRef, 'TURN ON');
//     return () => {
//       if (onTimeoutRef.current) clearTimeout(onTimeoutRef.current);
//     };
//   }, [onTime, scheduleAction]);

//   // Schedule the OFF action whenever offTime changes
//   useEffect(() => {
//     scheduleAction(offTime, false, offTimeoutRef, 'TURN OFF');
//     return () => {
//       if (offTimeoutRef.current) clearTimeout(offTimeoutRef.current);
//     };
//   }, [offTime, scheduleAction]);

//   const handleSaveSchedule = () => {
//     const newOn = timeInputOn || '';
//     const newOff = timeInputOff || '';

//     setOnTime(newOn);
//     setOffTime(newOff);
//     localStorage.setItem('dailyOnTime', newOn);
//     localStorage.setItem('dailyOffTime', newOff);

//     console.log(`📅 Daily schedule saved → ON at ${newOn || '—'} | OFF at ${newOff || '—'}`);
//   };

//   const handleClearSchedule = () => {
//     setOnTime('');
//     setOffTime('');
//     setTimeInputOn('');
//     setTimeInputOff('');
//     localStorage.removeItem('dailyOnTime');
//     localStorage.removeItem('dailyOffTime');

//     if (onTimeoutRef.current) clearTimeout(onTimeoutRef.current);
//     if (offTimeoutRef.current) clearTimeout(offTimeoutRef.current);

//     console.log('🗑️ Both daily schedules cleared');
//   };

//   const getNextTriggerString = (time) => {
//     if (!time) return 'Not set';
//     const now = new Date();
//     const [hours, minutes] = time.split(':').map(Number);
//     let next = new Date(now.getFullYear(), now.getMonth(), now.getDate(), hours, minutes, 0, 0);
//     if (next <= now) next.setDate(next.getDate() + 1);
//     return next.toLocaleString('en-US', {
//       weekday: 'short',
//       month: 'short',
//       day: 'numeric',
//       hour: 'numeric',
//       minute: '2-digit',
//     });
//   };

//   return (
//     <div style={{
//       padding: '20px',
//       border: '1px solid #ccc',
//       borderRadius: '8px',
//       maxWidth: '460px',
//       margin: '20px auto',
//       fontFamily: 'system-ui, sans-serif',
//       background: '#f9f9f9'
//     }}>
//       <h3>⏰ Daily ON / OFF Scheduler</h3>
//       <p style={{ marginBottom: '20px', color: '#555' }}>
//         Set two times per day. <strong>handleToggle</strong> will be forced ON at the first time and forced OFF at the second time.
//       </p>

//       {/* ON time picker */}
//       <div style={{ marginBottom: '20px' }}>
//         <label style={{ display: 'block', marginBottom: '5px', fontWeight: 600, color: '#28a745' }}>
//           Turn ON every day at:
//         </label>
//         <input
//           type="time"
//           value={timeInputOn}
//           onChange={(e) => setTimeInputOn(e.target.value)}
//           style={{
//             padding: '10px',
//             fontSize: '16px',
//             borderRadius: '4px',
//             border: '1px solid #999',
//             width: '100%'
//           }}
//         />
//       </div>

//       {/* OFF time picker */}
//       <div style={{ marginBottom: '20px' }}>
//         <label style={{ display: 'block', marginBottom: '5px', fontWeight: 600, color: '#dc3545' }}>
//           Turn OFF every day at:
//         </label>
//         <input
//           type="time"
//           value={timeInputOff}
//           onChange={(e) => setTimeInputOff(e.target.value)}
//           style={{
//             padding: '10px',
//             fontSize: '16px',
//             borderRadius: '4px',
//             border: '1px solid #999',
//             width: '100%'
//           }}
//         />
//       </div>

//       <div style={{ display: 'flex', gap: '10px', marginBottom: '20px' }}>
//         <button
//           onClick={handleSaveSchedule}
//           style={{
//             flex: 1,
//             padding: '12px',
//             background: '#007bff',
//             color: 'white',
//             border: 'none',
//             borderRadius: '4px',
//             fontSize: '16px',
//             cursor: 'pointer'
//           }}
//         >
//           💾 Save Both Times
//         </button>

//         <button
//           onClick={handleClearSchedule}
//           style={{
//             flex: 1,
//             padding: '12px',
//             background: '#dc3545',
//             color: 'white',
//             border: 'none',
//             borderRadius: '4px',
//             fontSize: '16px',
//             cursor: 'pointer'
//           }}
//         >
//           🗑️ Clear Both
//         </button>
//       </div>

//       {/* Status */}
//       <div style={{
//         padding: '12px',
//         background: '#f0f0f0',
//         borderRadius: '4px',
//         fontSize: '15px',
//         lineHeight: '1.5'
//       }}>
//         <strong>Next ON:</strong> {getNextTriggerString(onTime)}<br />
//         <strong>Next OFF:</strong> {getNextTriggerString(offTime)}
//       </div>

//       <small style={{ display: 'block', marginTop: '15px', color: '#666' }}>
//         Note: The page must stay open for the timers to run.<br />
//         (For production, move this to Firebase Cloud Functions cron jobs.)
//       </small>
//     </div>
//   );
// };

// export default DailyToggleScheduler;
/////////////////////////////////////////////////////////////////////////////////
// import React, { useState, useEffect, useRef, useCallback } from 'react';

// const DailyToggleScheduler = ({ handleToggle }) => {
//   const [scheduledTime, setScheduledTime] = useState(() => {
//     return localStorage.getItem('dailyToggleTime') || '';
//   });

//   const [timeInput, setTimeInput] = useState(scheduledTime);

//   const timeoutRef = useRef(null);

//   // ✅ Properly memoized with exhaustive deps — no lint errors
//   const scheduleNextToggle = useCallback(() => {
//     if (!scheduledTime || !handleToggle) return;

//     if (timeoutRef.current) {
//       clearTimeout(timeoutRef.current);
//     }

//     const now = new Date();
//     const [hours, minutes] = scheduledTime.split(':').map(Number);

//     let nextTrigger = new Date(
//       now.getFullYear(),
//       now.getMonth(),
//       now.getDate(),
//       hours,
//       minutes,
//       0,
//       0
//     );

//     if (nextTrigger <= now) {
//       nextTrigger.setDate(nextTrigger.getDate() + 1);
//     }

//     const delayMs = nextTrigger.getTime() - now.getTime();

//     console.log(
//       `✅ Daily toggle scheduled for ${nextTrigger.toLocaleString()} ` +
//       `(${Math.round(delayMs / 1000 / 60)} minutes from now)`
//     );

//     timeoutRef.current = setTimeout(() => {
//       console.log('🚀 Running scheduled handleToggle...');
//       handleToggle();

//       // Automatically reschedule for the next day
//       scheduleNextToggle();
//     }, delayMs);
//   }, [scheduledTime, handleToggle]);

//   // Run the scheduler whenever the memoized function changes
//   useEffect(() => {
//     scheduleNextToggle();

//     return () => {
//       if (timeoutRef.current) {
//         clearTimeout(timeoutRef.current);
//       }
//     };
//   }, [scheduleNextToggle]);

//   const handleSaveSchedule = () => {
//     if (!timeInput) return;
//     setScheduledTime(timeInput);
//     localStorage.setItem('dailyToggleTime', timeInput);
//     console.log(`📅 New daily schedule saved: ${timeInput} every day`);
//   };

//   const handleClearSchedule = () => {
//     setScheduledTime('');
//     setTimeInput('');
//     localStorage.removeItem('dailyToggleTime');
//     if (timeoutRef.current) {
//       clearTimeout(timeoutRef.current);
//     }
//     console.log('🗑️ Daily schedule cleared');
//   };

//   const getNextTriggerString = () => {
//     if (!scheduledTime) return 'No schedule set';
//     const now = new Date();
//     const [hours, minutes] = scheduledTime.split(':').map(Number);
//     let next = new Date(now.getFullYear(), now.getMonth(), now.getDate(), hours, minutes, 0, 0);
//     if (next <= now) next.setDate(next.getDate() + 1);
//     return next.toLocaleString('en-US', {
//       weekday: 'short',
//       month: 'short',
//       day: 'numeric',
//       hour: 'numeric',
//       minute: '2-digit',
//     });
//   };

//   return (
//     <div style={{
//       padding: '20px',
//       border: '1px solid #ccc',
//       borderRadius: '8px',
//       maxWidth: '420px',
//       margin: '20px auto',
//       fontFamily: 'system-ui, sans-serif',
//       background: '#f9f9f9'
//     }}>
//       <h3>⏰ Daily Toggle Scheduler</h3>
//       <p style={{ marginBottom: '20px', color: '#555' }}>
//         Choose a time (24-hour format). <strong>handleToggle</strong> will run automatically every day at that exact time.
//       </p>

//       <div style={{ marginBottom: '15px' }}>
//         <label style={{ display: 'block', marginBottom: '5px', fontWeight: 600 }}>
//           Schedule time:
//         </label>
//         <input
//           type="time"
//           value={timeInput}
//           onChange={(e) => setTimeInput(e.target.value)}
//           style={{
//             padding: '10px',
//             fontSize: '16px',
//             borderRadius: '4px',
//             border: '1px solid #999',
//             width: '100%'
//           }}
//         />
//       </div>

//       <div style={{ display: 'flex', gap: '10px', marginBottom: '20px' }}>
//         <button
//           onClick={handleSaveSchedule}
//           disabled={!timeInput}
//           style={{
//             flex: 1,
//             padding: '12px',
//             background: '#007bff',
//             color: 'white',
//             border: 'none',
//             borderRadius: '4px',
//             fontSize: '16px',
//             cursor: 'pointer'
//           }}
//         >
//           💾 Save Daily Schedule
//         </button>

//         <button
//           onClick={handleClearSchedule}
//           style={{
//             flex: 1,
//             padding: '12px',
//             background: '#dc3545',
//             color: 'white',
//             border: 'none',
//             borderRadius: '4px',
//             fontSize: '16px',
//             cursor: 'pointer'
//           }}
//         >
//           🗑️ Clear Schedule
//         </button>
//       </div>

//       {scheduledTime && (
//         <div style={{
//           padding: '12px',
//           background: '#d4edda',
//           borderRadius: '4px',
//           border: '1px solid #c3e6cb',
//           color: '#155724'
//         }}>
//           <strong>✅ Schedule active:</strong><br />
//           Every day at <strong>{scheduledTime}</strong><br />
//           Next run: <strong>{getNextTriggerString()}</strong>
//         </div>
//       )}

//       {!scheduledTime && (
//         <div style={{
//           padding: '12px',
//           background: '#f8d7da',
//           borderRadius: '4px',
//           border: '1px solid #f5c6cb',
//           color: '#721c24'
//         }}>
//           No daily schedule set.
//         </div>
//       )}

//       <small style={{ display: 'block', marginTop: '15px', color: '#666' }}>
//         Note: The page must stay open for the timer to run.<br />
//         (For production use, consider a server-side cron job with Firebase Functions.)
//       </small>
//     </div>
//   );
// };

// export default DailyToggleScheduler;